/**
 * IE11 support for crypto-browserify required by react-scripts
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/crypto
 */
window.crypto = window.crypto || window.msCrypto;
